<template>
<v-card flat tile >
  <template v-if="(step>0)" >
    <v-card-title
        class="overline py-0 black white--text" >
      <v-btn @click="step=0" icon small dark ><v-icon small >mdi-arrow-left</v-icon></v-btn>
      <v-divider vertical />
      <template v-if="step===1" >Space</template>
      <template v-if="(step===2)" >Location</template>
      <v-spacer/>
    </v-card-title>
    <v-divider/>
  </template>

  <v-window v-model="step" >
    <v-window-item >
      <v-card class="grey lighten-4" >
        <v-row >
          <v-col cols="12" >
            <v-card
              @click="step=1"
              class="elevation-5 mx-3" >
              <v-card-title class="py-1 grey lighten-4" >
                <v-icon class="mr-3" color="primary" >mdi-office-building-plus-outline</v-icon>
                New Space
                <v-spacer/>
                <v-btn small class="primary" style="width:180px;" >
                  Create space
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider/>

              <v-card-text >
                <ul>
                  <li>A space is like a business. With AppointmentGuru you can create multiple spaces in your account. </li>
                  <li>Create a new space if you need different branding, banking and invoice deails.</li>
                  <li>If you only need to add a new address to your business, consider rather adding a location</li>
                </ul>
              </v-card-text>

            </v-card>
          </v-col>

          <v-col cols="12" >
            <v-card
              @click="step=2"
              class="elevation-5 mx-3" >
              <v-card-title class="py-1 grey lighten-4" >
                <v-icon class="mr-3" color="primary" >mdi-map-marker-radius-outline</v-icon>
                New Location
                <v-spacer/>
                <v-btn small class="primary" style="width:180px;" >Create Location
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider/>

              <v-card-text >
                <ul>
                  <li>Add an address to an existing business.</li>
                  <li>Use this if you have a single business that operates out of more than one location.</li>
                  <li>A location will have it's own operating bours per practitioner, and you can assign appointment types in your space to this location.</li>
                </ul>
              </v-card-text>

            </v-card>
          </v-col>

        </v-row>
      </v-card>

    </v-window-item>

    <v-window-item >
      <space-wizard @close="handleDone" />
    </v-window-item>

    <v-window-item >
      <new-location-wizard :touch="locTouch" />
    </v-window-item>

    <!-- <locations space-id="1785" /> -->

  </v-window>
</v-card>
</template>

<script>
import SpaceWizard from './Index.vue'
import NewLocationWizard from '@/components/actions/wizards/NewLocationWizard/index.vue'
// import Locations from './Locations.vue'
export default {
  name: 'Decision',
  components: {
    SpaceWizard,
    NewLocationWizard
    // Locations
  },
  props: {
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      step: 0,
      locTouch: 0
    }
  },
  watch: {
    touch () {
      this.step = 0
      this.locTouch++
    }
  },
  methods: {
    handleDone () {
      this.$emit('close')
      if (this.$route.path === '/wizards/space') {
        this.$router.push({path: '/'})
      }
    }
  }
}
</script>
